import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { FooterComponent } from './features/footer/footer.component';
import { HeaderComponent } from './features/header/header.component';
import { View } from './shared/models/view.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, HeaderComponent, RouterOutlet, FooterComponent],
})

export class AppComponent {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly router = inject(Router);

  view = View;
  view$: Observable<View> = this.breakpointObserver
  .observe('(min-width: 600px)')
  .pipe(
    map((result: BreakpointState) => result.matches),
    map((desktop: boolean) => {
      if (!desktop) {
        return View.Mobile;
      } else {
        return View.DesktopLoggedIn;
      }
    }),
  );

  showHeaderFooter$: Observable<boolean> = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    startWith(this.router),
    map(() => !this.router.url.includes('/create-notification') && !this.router.url.includes('/create-local-notification'))
  );
}
